import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { StatsigProvider } from '@statsig/react-bindings';

import { Error, Layout, numeratorInsightsLogoImage as NumeratorInsightsLogo } from '@utilities';

import { readReportPublicToken } from '@api/reports';
import { readSurveyPublicToken } from '@api/surveys';
import { setInstantSurveyAuthToken } from '../../utilities/api/instant_survey/api';

import Footer from '../../components/Footer';
import Page from '@src/app/pages/Dashboard/layouts/Page';
import { Report } from '@src/app/pages/Dashboard/pages/Report';
import { Survey } from '@src/app/pages/Dashboard/pages/Survey';

import styles from './_index.module.scss';

const Share = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [isSurvey, setIsSurvey] = useState(false);

  const { token } = useParams();

  let type;
  const pathname = window.location.pathname;
  if (pathname.includes('/share/survey/')) type = 'survey';
  else if (pathname.includes('/share/narrative/')) type = 'narrative';
  else type = 'report';

  useEffect(() => {
    const getData = async () => {
      let response;
      try {
        if (type === 'report') {
          response = await readReportPublicToken({ publicToken: token });
          if (response) {
            setIsSurvey(false);
            setData(response?.data);
            return;
          }
        } else if (type === 'survey') {
          response = await readSurveyPublicToken({ publicToken: token });
          if (response) {
            setIsSurvey(true);
            setInstantSurveyAuthToken(response?.data?.serviceToken);
            setData({
              atlasInstantSurveyRef: response?.data?.atlasInstantSurveyRef,
              id: response?.data?.surveyId,
              instantSurveyTypeId: response?.data?.instantSurveyTypeId,
            });
            return;
          }
        }
      } catch (error) {
        console.error(error);
        setError(error);
      }
    };

    getData();
  }, [token, type]);

  if (error) return <Error status={error?.response?.status} />;

  if (!data) return null;

  return (
    <div className={styles['share']}>
      <main>
        <Page>
          <Layout.Column>
            <NumeratorInsightsLogo
              aria-label="Numerator Logo"
              className={styles['share-logo']}
              data-testid="share-logo"
              role="img"
            />
            {isSurvey ? (
              <StatsigProvider
                options={{
                  environment: { tier: import.meta.env.VITE_ENVIRONMENT },
                }}
                sdkKey={import.meta.env.VITE_STATSIG}
                user={{
                  userID: 'public_share',
                }}
              >
                <Survey data={data} publicToken={token} />
              </StatsigProvider>
            ) : (
              <Report id={data} publicToken={token} />
            )}
          </Layout.Column>
        </Page>
      </main>
      <Footer />
    </div>
  );
};

export default Share;
